import React, { useState, useEffect } from 'react'
import UserTable from "./UserTable"
import UserFilters from "./UserFilters"
import { Pagination } from "antd"
import { userList } from "../../../services/api/UserService"
import NewUser from "./new/NewUser"
import UseDebounce from '../helpers/UseDebounce'

function UsersPage() {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')
    const [users, setUsers] = useState([])
    const [userName, setUserName] = useState('')
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [isActive, setIsActive] = useState('active')

    const _handleChangeUserName = (value) => {
        setUserName(value)
        setPage(1)
    }

    const _handlePageChange = (page) => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const _handleChageStatus = (status) => {
        setIsActive(status)
        setPage(1)
    }

    const _fetchListUser = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                username: userName,
                is_active: isActive === "active" ? true : (isActive === "inactive" ? false : ''),
            }

            const response = await userList(`page=${page}&limit=${limit}`, payload)

            const { success, data, message } = response

            if (!success) {
                setLoading(false)

                return setError(message)
            }

            setLoading(false)
            setUsers(data.users)
            setTotal(data.total)
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const debounceName = userName === '' ? UseDebounce(userName, 0) : UseDebounce(userName, 500)

    const _reset = () => {
        setPage(1)
        setUserName('')
    }

    useEffect(() => {
        _fetchListUser()
        // eslint-disable-next-line
    }, [debounceName, page, limit, isActive])

    return (
        <div className='UsersPage'>
            <div className="Heading mb-3 d-flex align-items-center justify-content-between">
                <h3 className="mb-0">List Users</h3>
                <NewUser reloadUsers={_fetchListUser} onReset={_reset} />
            </div>
            <div className="Section">
                <div className="HeaderList">
                    <UserFilters
                        userName={userName}
                        onChangeUserName={_handleChangeUserName}
                        handleChageStatus={_handleChageStatus}
                        isActive={isActive}
                    />
                </div>
                <div className="ContentLists">
                    <UserTable reloadUsers={_fetchListUser} loading={loading} error={error} users={users} />
                </div>
                <div className="FooterList">
                    <div className="Pagination">
                        <Pagination
                            current={page}
                            total={total}
                            pageSize={limit}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>
                                    {`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total}`}</strong> users
                                </div>}
                            onChange={_handlePageChange}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={_handleShowSizeChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UsersPage
